<template>
  <div v-if="eventIdLoaded" class="event-page">
    <event-header
      v-if="eventData"
      :event-data="eventData"
      :event-id="eventId"
      @update-data="fetchEventData"
    />

    <el-tabs
      v-model="activeTab" readonly
      class="event-page__tabs"
      @tab-click="handleChangeTab"
      size="large"
    >
      <el-tab-pane label="Log" name="newsfeed" lazy>
        <event-newsfeed
          :event-id="eventId"
          :is-user-logged-in="isUserLoggedIn"
        />
      </el-tab-pane>
      <el-tab-pane label="Participants" name="participants" lazy>
        <event-participants
          :event-id="eventId"
          :is-admin="isAdmin"
          ref="participants"
        />
      </el-tab-pane>
      <!-- <el-tab-pane label="Photo album" name="photo-album" lazy>
        <event-photo-album :event-id="eventId" />
      </el-tab-pane> -->
      <el-tab-pane label="Invitations" name="invitations" lazy v-if="isAdmin">
        <event-invitations :event-id="eventId" ref="invitations" />
      </el-tab-pane>
      <el-tab-pane label="Applications" name="applications" lazy v-if="isAdmin">
        <event-applications
          :event-id="eventId"
          @update-data="handleUpdateData"
          ref="applications"
        />
      </el-tab-pane>
      <el-tab-pane label="Vacancies" name="vacancies" lazy>
        <event-vacancies 
            :event-id="eventId" 
            :is-admin="isAdmin" 
            :activity-id="this.eventData.activityId" 
            ref="vacancies" />
      </el-tab-pane>
      <el-tab-pane label="Messages" name="messages" lazy v-if="isAdmin">
        <event-messages :event-id="eventId" ref="messages" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { GET_DESCRIPTION } from '@/store/mutationTypes.js';
import { getEvent, getEventIdByLink } from '@/api/events.js';

import EventHeader from '@/components/events/EventHeader.vue';
import EventNewsfeed from '@/components/events/EventNewsfeed.vue';
import EventParticipants from '@/components/events/EventParticipants.vue';
import EventPhotoAlbum from '@/components/events/EventPhotoAlbum.vue';
import EventInvitations from '@/components/events/EventInvitations.vue';
import EventApplications from '@/components/events/EventApplications.vue';
import EventTeams from '@/components/events/EventTeams.vue';
import EventMessages from '@/components/events/EventMessages.vue';
import EventVacancies from '@/components/events/EventVacancies.vue';

export default {
  name: 'EventPage',
  components: {
    EventHeader,
    EventNewsfeed,
    EventParticipants,
    EventPhotoAlbum,
    EventInvitations,
    EventApplications,
    EventTeams,
    EventMessages, 
    EventVacancies,
  },
  data() {
    return {
      eventData: null,
      eventId: null,
      eventIdLoaded: false,
    };
  },
  computed: {
    activeTab: {
      get() {
        return this.$route.query.tab || 'newsfeed';
      },
      set(value) {
          this.$router.push({
            query: {
              tab: value,
            },
          });
        },
    },
    isAdmin() {
      return this.eventData ? this.eventData.hasAdminRights : false;
    },
    currentUser() {
      return this.$store.state.user;
    },
    isUserLoggedIn() {
      const { currentUser } = this;
      return Boolean(currentUser.userId);
    },
  },
  methods: {
    async fetchEventData() {
      const { eventId } = this;
      const { data, success } = await getEvent({ eventId });

      if (success) {
        this.eventData = data;
      }
    },
    handleChangeTab({ name }) {
      const { eventId, activeTab } = this;

      if (name !== activeTab) {
        this.$router.push({
          route: 'Event',
          params: {
            eventId: eventId,
          },
          query: {
            tab: name,
          },
        });
      }
    },
    handleUpdateData() {
      this.fetchEventData();
      if (this.$refs.applications) {
        this.$refs.applications.fetchApplications();
      }
      if (this.$refs.participants) {
        this.$refs.participants.fetchEventParticipants();
      }
      if(this.$refs.vacancies) {
        this.$refs.vacancies.fetchVacancies();
      }
    },
  },
  async created() {
    const { data } = await getEventIdByLink({ link: this.$route.params.link });

    if (!(data && data.eventId)) {
      this.$router.replace({
        name: 'NotFound',
      });
    } else {
      this.eventId = data.eventId;
      await this.fetchEventData();
      this.eventIdLoaded = true;
    }

    if (!this.$store.state.descriptions.activityType || this.$store.state.descriptions.activityType.length === 0) {
      this.$store.dispatch(GET_DESCRIPTION, { key: 'activityType', entity: 'Event' });
    }

    if (!this.$store.state.descriptions.vacancyStatus || this.$store.state.descriptions.vacancyStatus.length === 0) {
      this.$store.dispatch(GET_DESCRIPTION, { key: 'vacancyStatus', entity: 'Vacancy' });
    }
  },
};
</script>

<style lang="scss">
@import '~@/styles/shared/_globals.scss';

.event-page {
  &__tabs {
    .el-tabs__header {
      margin-bottom: var(--global-dimension-size-350);
    }

    .el-tabs__item {
      @include from('lg') {
        font-size: var(--font-size-500);
        height: var(--global-dimension-size-600);
      }
    }
  }
}
</style>
